export const gameActionType = {
  SET_GAME_ID: 'SET_GAME_ID',
  SET_PLAYER_SIGN: 'SET_PLAYER_SIGN',
};
